// extracted by mini-css-extract-plugin
export default {"checkbox":"mDQMIO7SB0paqSeEfzPA","selections":"t9azak4UXMgMTKAeh_Is"};